/**
 * @generated SignedSource<<5d28f8209f8ade44ef51275982d7ecee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateResolutionStatusesInput = {
  reportId: string;
  resolutionIds?: ReadonlyArray<string | null> | null;
  status?: string | null;
};
export type useReportResolutionUpdateStatusesMutation$variables = {
  input: UpdateResolutionStatusesInput;
  resolutionSection?: string | null;
  anomalies?: ReadonlyArray<string | null> | null;
};
export type useReportResolutionUpdateStatusesMutation$data = {
  readonly updateResolutionStatuses: {
    readonly report: {
      readonly reviewStatus: string | null;
      readonly resolutionProgress: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"ReportResolution_report" | "ReportResolutionTable_report">;
    };
  } | null;
};
export type useReportResolutionUpdateStatusesMutation = {
  variables: useReportResolutionUpdateStatusesMutation$variables;
  response: useReportResolutionUpdateStatusesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anomalies"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resolutionSection"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolutionProgress",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportResolutionUpdateStatusesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateResolutionStatusesPayload",
        "kind": "LinkedField",
        "name": "updateResolutionStatuses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "kind": "LinkedField",
            "name": "report",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportResolution_report"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportResolutionTable_report"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useReportResolutionUpdateStatusesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateResolutionStatusesPayload",
        "kind": "LinkedField",
        "name": "updateResolutionStatuses",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "kind": "LinkedField",
            "name": "report",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": "pendingResolutions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "updateStatus": "pending"
                    }
                  }
                ],
                "concreteType": "ReportResolutionsConnection",
                "kind": "LinkedField",
                "name": "reportResolutions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AnomalyCount",
                "kind": "LinkedField",
                "name": "anomalyCounts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "anomalies",
                        "variableName": "anomalies"
                      },
                      {
                        "kind": "Variable",
                        "name": "status",
                        "variableName": "resolutionSection"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                  }
                ],
                "concreteType": "ReportResolutionsConnection",
                "kind": "LinkedField",
                "name": "filteredReportResolutions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportResolution",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anomalyTypes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updateStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "responseData",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolutionKind",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b3d7ec6f291d1f357ab65f305de09798",
    "id": null,
    "metadata": {},
    "name": "useReportResolutionUpdateStatusesMutation",
    "operationKind": "mutation",
    "text": "mutation useReportResolutionUpdateStatusesMutation(\n  $input: UpdateResolutionStatusesInput!\n  $resolutionSection: String\n  $anomalies: [String]\n) {\n  updateResolutionStatuses(input: $input) {\n    report {\n      reviewStatus\n      resolutionProgress\n      ...ReportResolution_report\n      ...ReportResolutionTable_report\n      id\n    }\n  }\n}\n\nfragment ReportResolutionTable_report on Report {\n  filteredReportResolutions(input: {anomalies: $anomalies, status: $resolutionSection}) {\n    nodes {\n      id\n      anomalyTypes\n      currentValue\n      status\n      updateStatus\n      responseData\n      resolutionKind\n    }\n  }\n  id\n}\n\nfragment ReportResolution_report on Report {\n  id\n  reviewStatus\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n  anomalyCounts {\n    type\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "3567cbffe6433e2574110067df0a127c";

export default node;
